import styled from 'styled-components/macro'
import { DialogBox } from '../dialogbox'

export const StyledDialogBox = styled(DialogBox)`
  max-width: 24rem;
`
